import config from '../config';
import { handleResponse } from "./builder";

export const send = (contact) => fetch(`${config.apiUrl}/contact`, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify(contact)
})
    .then(handleResponse)
